// extracted by mini-css-extract-plugin
module.exports = {"Admin":"Admin_Admin__i_ycN","Admin_nav":"Admin_Admin_nav__20Roq","active":"Admin_active__2TRjc"};